import { useEffect, useState } from 'react';
import React from 'react';

import { AuthAlert } from '../../components/auth/AuthAlert';
import { AuthButton } from '../../components/auth/AuthButton';
import { AuthFooterLink } from '../../components/auth/AuthFooterLink';
import { AuthInput } from '../../components/auth/AuthInput';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { userReducer } from '../../store/reducers/user.reducer';
import { getResetPasswordRequestSent } from '../../store/selectors/user.selector';
import { history } from '../../store/store';

const { resetPassword, clearResetPasswordState } = userReducer.actions;

export const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const dispatch = useAppDispatch();
  const resetPasswordRequestSent = useAppSelector(getResetPasswordRequestSent);

  useEffect(() => {
    dispatch(clearResetPasswordState());
  }, [dispatch]);

  const validateEmail = (value: string) => {
    if (!value) {
      setEmailError('Please provide your email');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateEmail(email)) {
      dispatch(resetPassword({ email }));
    }
  };

  return (
    <AuthLayout
      title="Reset password"
      subtitle="Enter your email and we'll send you reset instructions."
      cardClassName="md:max-h-[90dvh]"
    >
      {resetPasswordRequestSent ? (
        <>
          <AuthAlert
            type="success"
            message="If an account exists with the email you provided, we've sent password reset instructions."
          />
          <AuthButton onClick={() => history.push('/login')}>Return to Login</AuthButton>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <AuthInput
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            error={emailError}
            autoComplete="email"
            autoFocus
            name="email"
          />

          <AuthButton type="submit">Reset Password</AuthButton>
        </form>
      )}

      {!resetPasswordRequestSent && <AuthFooterLink text="Remember your password?" linkText="Log in" to="/login" />}
    </AuthLayout>
  );
};
